<template>
  <div class="videoPlaye">
    <el-dialog :visible.sync="show" custom-class="video-playe-dialog">
      <div v-if="false" slot="title"></div>
      <vue-core-video-player v-if="show" :src="url"></vue-core-video-player>
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  computed: {
    show: {
      get: function () {
        return Boolean(this.url || undefined)
      },
      set: function (newValue) {
        this.url = ''
      }
    }
  },
  data() {
    return {
      url: ''
    }
  },
  methods: {
    async showVideo(data) {
      this.url = data.url
      // this.getBlod(data.url).then(res => {
      //   this.url = URL.createObjectURL(res.data)
      //   console.log('播放器', this.url)
      // })
    },
    getBlod(url) {
      if (!url) return ''
      let httpDefaultOpts = {
        baseURL: process.env.NODE_ENV === 'development' ? 'airworthiness_certified' : 'https://eh-workflow.oss-cn-shenzhen.aliyuncs.com',
        method: 'get',
        cache: false,
        url: url.replace('https://eh-workflow.oss-cn-shenzhen.aliyuncs.com', ''),
        timeout: 30000,
        responseType: 'blob',
        headers: { 'Content-Type': 'multipart/form-data', 'Accept': '*/*' }
      }
      // console.log(httpDefaultOpts)
      return axios(httpDefaultOpts)
    }
  }
}
</script>
<style lang="scss">
.video-playe-dialog {
  margin: 0;
  border: 0 none;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    border: 0 none;
    height: 100%;
  }
}
</style>
